import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-notes-modal',
  templateUrl: './notes-modal.component.html',
  styleUrls: ['./notes-modal.component.css']
})
export class NotesModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>();
  @Input() notes: any;
  @Input() source: any;

  constructor(
    private tripService : TripService,
    private router: Router
  ){}
  ngOnInit() {
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  onUpdateNote() {
    const tripId = this.notes?._id ? this.notes._id : this.notes?.id
    //   if ( !this.notes.generalNotes?.trim() && !this.notes.privateNotes?.trim() && !this.notes.billingNotes?.trim()) {
    //    return;
    //  }

    const payload = {
      generalNotes : this.notes.generalNotes,
      privateNotes : this.notes.privateNotes,
      billingNotes : this.notes.billingNotes
    }

    this.tripService.updateNotes(tripId, this.source, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
       this.onCloseModal();
      }
    }, (err:any) => {
      sweetAlert("Error", err, "error", "Ok");
    }
    );
  }
}
